module.exports = __webpack_public_path__ + "static/img/04_03.ffd03c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/tips/04_03.png
// module id = NSaQ
// module chunks = 1